import React, { useState, useEffect, useRef } from "react";
import { compose } from "redux";
import useStateWithCallback from 'use-state-with-callback';

import styles from "fantastic/components/hoc/styles";

import connectActions from "fantastic/lib/connectActions";
import actions from "fantastic/actions";

const Html = ({
  id,
  style,
  contents,
  update,
  preview,
  editId,
  meta: { edit }
}) => {

  const handleOpen = () => {
    if (preview)
      return;
    editId(id);
  }

  const handleClick = (e) => {
    e.preventDefault();
    return false;
  }

  return (
    <div style={style}>
      <div
        className="ftc-html-block"
        onDoubleClick={handleOpen}
        onClick={handleClick}
        dangerouslySetInnerHTML={{ __html: contents }}
      />
    </div>
  );
};

export default compose(
  connectActions({
    update: actions.updateNode,
    editId: actions.editId
  }),
  styles("background", "padding", "visibility")
)(Html);

